import {
  ApiDateSchema,
  CONTRACT_TYPES,
  ContractTypeSchema,
  CurrencySchema,
  ObjectIdSchema,
  PlanInputSchema,
  TrialDurationSchema,
  withNullAsOptional,
} from '@vy/types';
import { oz } from '@vy/utils';
import { ProRateSettingsSchema } from './create-plan-form-sub-types';

export const planNameSchema = oz
  .string({ message: 'Plan name is required' })
  .min(1, { message: 'Plan name is required' });

export const contractNameSchema = oz
  .string({ message: 'Contract name is required' })
  .min(1, { message: 'Contract name is required' });

const BasePlanSettingsSchema = PlanInputSchema.pick({
  trial: true,
  status: true,
  billingData: true,
  purchaseOrder: true,
  basedFromPlanId: true,
}).extend({
  name: oz.string(),
  signatureDate: withNullAsOptional(ApiDateSchema).optional(),
  customerId: withNullAsOptional(ObjectIdSchema).optional(),
  startDate: withNullAsOptional(ApiDateSchema).optional(),
  currencyOverride: withNullAsOptional(CurrencySchema).optional(),
  contractType: ContractTypeSchema.default(CONTRACT_TYPES.Standard).optional(),
  notes: oz.string().max(500).optional(),
});

export const PlanSettingsInputFormSchema = BasePlanSettingsSchema.extend({
  proRataSetting: ProRateSettingsSchema,
});

export const ParentAgreementPlanSettingsSchema = BasePlanSettingsSchema.extend({
  proRataSetting: ProRateSettingsSchema.optional(),
});

export function getPlanSettingsInputFormSchema(isPlanForm: boolean, isParentAgreement?: boolean) {
  const baseSchema = isParentAgreement ? ParentAgreementPlanSettingsSchema : PlanSettingsInputFormSchema;

  const schemaWithDefinedName = baseSchema.omit({ name: true }).extend({
    name: isPlanForm ? planNameSchema : contractNameSchema,
  });

  if (isPlanForm) {
    return schemaWithDefinedName;
  }

  return schemaWithDefinedName
    .omit({
      customerId: true,
      startDate: true,
      trial: true,
    })
    .extend({
      customerId: ObjectIdSchema,
      startDate: ApiDateSchema,
      trial: TrialDurationSchema.nullable().optional(),
    });
}

export type PlanSettingsInputForm = oz.infer<typeof PlanSettingsInputFormSchema>;
